import { Injectable } from '@angular/core';
import { HttpInterceptor } from '@angular/common/http';
import { HttpRequest } from '@angular/common/http';
import { HttpHandler } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpSentEvent } from '@angular/common/http';
import { HttpHeaderResponse } from '@angular/common/http';
import { HttpProgressEvent } from '@angular/common/http';
import { HttpResponse } from '@angular/common/http';
import { HttpUserEvent } from '@angular/common/http';
import { Router } from '@angular/router';
import { JwtService } from './jwt.service';


@Injectable()
export class RequestInterceptor implements HttpInterceptor {

  constructor(private tokenService: JwtService,
    private router: Router,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent
    | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {

    const headersConfig = {
      'Accept': 'application/json',
      'x-requestid': this.newGuid()
    };

    let anonymousHeader = req.clone({ setHeaders: headersConfig });

    //var  anonymous = (/true/i).test(anonymousHeader.headers.get('anonymous'));

    //if (anonymous) {
    //  return next.handle(anonymousHeader).pipe();
    //}


    if (this.tokenService.hasToken() && !this.tokenService.isExpired()) {
      const jwt = this.tokenService.getToken();
      headersConfig['Authorization'] = `Bearer ${jwt}`;
    }

    else {
      this.tokenService.destroyToken();
      //this.router.navigateByUrl('/authentication/login');
    }

    const request = req.clone({ setHeaders: headersConfig });
    return next.handle(request).pipe();
  }

  newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {

      const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}
